import { render, staticRenderFns } from "./Departments.html?vue&type=template&id=284d1e6e&"
import script from "./Departments.js?vue&type=script&lang=js&"
export * from "./Departments.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports